import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../components/ui/dialog';
import { Button } from '../../components/ui/button';
import { Plane, Car, Calendar, Building2, Users, CheckCircle2, ArrowRight } from 'lucide-react';

const ExplanationModal = ({ 
  open, 
  onOpenChange,
  onStartFilling
}) => {
  const { t } = useLanguage();

  const features = [
    {
      icon: Plane,
      title: t('myTrip.explanation.transport'),
      description: t('myTrip.explanation.transportDesc')
    },
    {
      icon: Calendar,
      title: t('myTrip.explanation.days'),
      description: t('myTrip.explanation.daysDesc')
    },
    {
      icon: Building2,
      title: t('myTrip.explanation.accommodation'),
      description: t('myTrip.explanation.accommodationDesc')
    },
    {
      icon: Users,
      title: t('myTrip.explanation.dependents'),
      description: t('myTrip.explanation.dependentsDesc')
    }
  ];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg max-h-[90vh] !p-0">
        <DialogHeader className="p-4 sm:p-6 pb-2">
          <DialogTitle className="flex items-center gap-2 text-lg sm:text-xl">
            <CheckCircle2 className="w-5 h-5 sm:w-6 sm:h-6 text-orange-500" />
            {t('myTrip.explanation.title')}
          </DialogTitle>
          <DialogDescription className="text-sm sm:text-base">
            {t('myTrip.explanation.description')}
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-3 sm:space-y-4 px-4 sm:px-6 pb-4 overflow-y-auto">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div 
                key={index}
                className="flex items-start gap-3 sm:gap-4 p-2 sm:p-3 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors"
              >
                <div className="p-2 rounded-lg bg-orange-100 dark:bg-orange-900/30 flex-shrink-0">
                  <Icon className="w-4 h-4 sm:w-5 sm:h-5 text-orange-600" />
                </div>
                <div className="min-w-0">
                  <h4 className="font-medium text-sm sm:text-base">{feature.title}</h4>
                  <p className="text-xs sm:text-sm text-slate-500">{feature.description}</p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 p-4 sm:p-6 pt-2 border-t">
          <Button
            variant="outline"
            className="flex-1 rounded-full order-2 sm:order-1"
            onClick={() => onOpenChange(false)}
          >
            {t('myTrip.explanation.later')}
          </Button>
          <Button
            className="flex-1 rounded-full bg-orange-500 hover:bg-orange-600 order-1 sm:order-2"
            onClick={() => {
              onOpenChange(false);
              onStartFilling();
            }}
          >
            {t('myTrip.explanation.start')}
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ExplanationModal;
